export const SORT_BY = { asc: 'ASC', desc: 'DESC', default: 'DEFAULT' };
